// eslint-disable-next-line import/prefer-default-export
export const isLocal = process.env.LOCAL === 'true';
